class EstimateShippingDate {
  constructor() {}

  calculateShipping(hasStock, productionDays, isoCode = 'ES') {
    const preparationDays = 2;
    let prodDays = productionDays;
    if (hasStock > 0) {
      prodDays = 0;
    } else {
      if (!productionDays || productionDays <= 0 || isNaN(productionDays)) {
        prodDays = 15;
      }
    }
    const shippingDays = isoCode === 'ES' ? 2 : 3;
    const totalWorkingDays = prodDays + preparationDays + shippingDays;
    const currentDate = new Date();
    const estimatedDeliveryDate = this.addWorkingDays(currentDate, totalWorkingDays);
    let finalDeliveryDate = new Date(estimatedDeliveryDate);
    if (finalDeliveryDate.getDay() === 5) {
      finalDeliveryDate.setDate(finalDeliveryDate.getDate() + 3);
    }
    const weekStart = this.getWeekStart(finalDeliveryDate);
    const weekEnd = this.getWeekEnd(finalDeliveryDate);
    const startDateFormatted = `${weekStart.getDate().toString().padStart(2, '0')}/${(weekStart.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`;
    const endDateFormatted = `${weekEnd.getDate().toString().padStart(2, '0')}/${(weekEnd.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`;

    const result = `${startDateFormatted} - ${endDateFormatted}`;
    return { result, weekStart, weekEnd };
  }

  addWorkingDays(startDate, daysToAdd) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getWeekStart(date) {
    const result = new Date(date);
    const dayOfWeek = result.getDay();
    const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    result.setDate(result.getDate() + daysToMonday);
    return result;
  }
  getWeekEnd(date) {
    const result = new Date(date);
    const dayOfWeek = result.getDay();
    const daysToFriday = dayOfWeek === 0 ? -2 : 5 - dayOfWeek;
    result.setDate(result.getDate() + daysToFriday);
    return result;
  }
}
